module.exports = __webpack_public_path__ + "img/code.1d8b80a9.png";